module.exports = __webpack_public_path__ + "static/img/new.131ff710.png";